import { PublicMarketingDetailPage } from "@/pages/public/marketing/marketing-detail";

export function ArticleDetailPage() {
  return <PublicMarketingDetailPage categoryPath="articles" />;
}

